// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/public/imagebg.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chat-area {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  background: #fff;
  min-width: 0;
  position: relative;
  transition: all 0.3s ease-in-out;
}

.messages {
  flex: 1 1;
  overflow-y: auto;
  padding: 32px 0 50px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  position: relative;
  height: 70vh;
  max-height: 100%;
  scroll-behavior: smooth;
  transition: all 0.6s cubic-bezier(0.4, 0, 0.2, 1);
  /* Hide scrollbar */
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* Internet Explorer 10+ */
}

/* Hide scrollbar for WebKit browsers (Chrome, Safari, Edge) */
.messages::-webkit-scrollbar {
  display: none;
}

.messages.with-content {
  padding: 16px 0 50px 0;
}

.message {
  max-width: 1300px;
  width: 60%;
  font-size: 1.1rem;
  line-height: 1.6;
  word-break: break-word;
  display: block;
  box-shadow: none;
  border: none;
  padding: 0;
  background: none;
  color: #17202B;
  margin-left: auto;
  margin-right: auto;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  transform: translateY(0);
  opacity: 1;
}

/* Responsive width adjustments for messages */
@media (max-width: 1199px) {
  .message, .message.user, .message.ai {
    width: 80%;
  }
}

@media (max-width: 899px) {
  .message, .message.user, .message.ai {
    width: 90%;
  }
}

@media (max-width: 767px) {
  .message, .message.user, .message.ai {
    width: 95%;
  }
}

@media (max-width: 599px) {
  .message, .message.user, .message.ai {
    width: 98%;
  }
}

@media (max-width: 479px) {
  .message, .message.user, .message.ai {
    width: 99%;
  }
}

.message.entering {
  transform: translateY(20px);
  opacity: 0;
}

.message.user {
  border-radius: 15px;
  padding: 10px 0px;
  margin-top: 8px;
  margin-bottom: 4px;
  padding-top: 14px;
  padding-bottom: 14px;
  color: #17202B;
  display: flex;
  justify-content: flex-end;
  margin-left: 0px; /* leave space on left for AI avatar */
  margin-right: 0;
}

.user-message-content {
  text-align: right;
  font-size: 16px;
  color: #17202B;
  border-radius: 15px;
  max-width: 520px;
  min-width: 0;
  align-self: flex-end;
  width: fit-content;
  margin-left: auto;
  padding: 18px 18px;
  border: 1px solid #D5D5D5;
}

.message.user .copy-btn {
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.18s;
}

.message.user:hover .copy-btn,
.message.user:focus-within .copy-btn {
  opacity: 1;
  pointer-events: auto;
}

.message.ai {
  background: none;
  border-radius: 23px;
  box-shadow: none;
  padding: 10px 28px;
  margin-top: 8px;
  color: #17202B;
  max-width: 1300px;
  width: 60%;
  margin-left: 0;
  margin-right: 0;
  text-align: left;
  background: #fff;
  color: #222;
  border-radius: 15px;
  padding: 18px 18px;
  min-width: 0;
  box-shadow: 0 1px 4px rgba(0,0,0,0.04);
  margin-bottom: 4px;
  align-self: flex-start;
  display: block;
  width: fit-content;
}

.input-area {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
  background: none;
  border: none;
  box-shadow: none;
  margin: 0 auto 0px auto;
  max-width: 600px;
  width: 100%;
  transition: all 0.6s cubic-bezier(0.4, 0, 0.2, 1);
  transform: translateY(0);
  opacity: 1;
}

.input-area {
  margin-top: 0;
}

.input-area.with-messages {
  margin-top: 16px;
  margin-bottom: 16px;
  transform: translateY(0);
  opacity: 1;
}

.input-area.initial-state {
  transform: translateY(20px);
  opacity: 0.8;
}

.chat-input {
  flex: 1 1;
  padding: 22px 0px;
  border-radius: 24px;
  border: 1.5px solid #EEECF9;
  background: #EEECF9;
  color: #686868;
  font-size: 1.08rem;
  margin-right: 12px;
  outline: none;
  transition: border 0.2s, box-shadow 0.2s;
  box-shadow: 0 2px 8px rgba(23,32,43,0.06);
  min-width: 0;
}

.chat-input:focus {
  border: 1.5px solid #2F80ED;
  background: #fff;
  box-shadow: 0 4px 16px rgba(47,128,237,0.10);
}

.empty-center-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  min-height: 90vh;
  width: 100%;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  padding-top: 20vh;
  transition: all 0.6s cubic-bezier(0.4, 0, 0.2, 1);
  opacity: 1;
  transform: translateY(0);
}

.empty-center-wrapper.fading {
  opacity: 0;
  transform: translateY(-20px);
}

.empty-chat-headline {
  text-align: center;
  font-size: 20px;
  font-weight: 700;
  color: #686868;
  margin-bottom: 20px;
  letter-spacing: -0.5px;
  line-height: 60px;
  opacity: 0.92;
}

.bot-picker-row {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 0;
  margin-top: 32px;
  margin-bottom: 18px;
  background: none;
  border-top: none;
  border-bottom: none;
  transition: all 0.6s cubic-bezier(0.4, 0, 0.2, 1);
  opacity: 1;
  transform: translateY(0);
}

.bot-picker-row.fading {
  opacity: 0;
  transform: translateY(-10px);
}

.bot-picker-btn {
  background: #EEECF9;
  color: #2F80ED;
  border: none;
  border-radius: 999px;
  padding: 8px 20px;
  font-size: 1rem;
  font-weight: 500;
  margin-right: 6px;
  cursor: pointer;
  transition: background 0.18s, color 0.18s, box-shadow 0.18s;
  box-shadow: 0 1px 4px rgba(23,32,43,0.04);
  outline: none;
  position: relative;
}

.bot-picker-btn:last-child {
  margin-right: 0;
}

.bot-picker-btn:hover:not(:disabled), .bot-picker-btn:focus:not(:disabled) {
  background: #2654FF1A;
  color: #EEECF9;
  box-shadow: 0 2px 8px rgba(47,128,237,0.08);
}

.bot-picker-btn.active {
  background: #2654FF1A;
  color: #EEECF9;
  font-weight: bold;
  box-shadow: 0 4px 16px rgba(47,128,237,0.10);
}

.bot-picker-btn:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.bot-btn-tooltip-wrapper {
  position: relative;
  display: inline-block;
}

.bot-tooltip {
  visibility: hidden;
  opacity: 0;
  position: absolute;
  left: 50%;
  top: 120%;
  transform: translateX(-50%);
  background: #EEECF9;
  color: #17202B;
  padding: 7px 16px;
  border-radius: 8px;
  font-size: 0.98rem;
  font-weight: 500;
  white-space: nowrap;
  pointer-events: none;
  z-index: 10;
  box-shadow: 0 2px 8px rgba(23,32,43,0.10);
  transition: opacity 0.18s, visibility 0.18s;
  max-width: 250px;
  width: 250%;
  word-wrap: break-word;
  white-space: normal;
  text-align: center;
}

.disclaimer-text {
  font-size: 14px;
  color: #B5B5B5;
  text-align: center;
  width: 60%;
  max-width: 1300px;
  margin: 0 auto;
}

/* Responsive width adjustments for disclaimer text */
@media (max-width: 1199px) {
  .disclaimer-text {
    width: 80%;
  }
}

@media (max-width: 899px) {
  .disclaimer-text {
    width: 90%;
    font-size: 13px;
  }
}

@media (max-width: 767px) {
  .disclaimer-text {
    width: 95%;
    font-size: 12px;
  }
}

@media (max-width: 599px) {
  .disclaimer-text {
    width: 98%;
    font-size: 11px;
  }
}

@media (max-width: 479px) {
  .disclaimer-text {
    width: 99%;
    font-size: 10px;
  }
}

@media (max-width: 319px) {
  .disclaimer-text {
    width: 100%;
    font-size: 9px;
  }
}

.tooltip-title {
  display: block;
  font-weight: 600;
  margin-bottom: 5px;
}

.tooltip-content {
  display: block;
  font-weight: 400;
}

.bot-btn-tooltip-wrapper:hover .bot-tooltip {
  visibility: visible;
  opacity: 1;
}

.indicator{
  width: 60%;
  max-width: 1300px;
  padding-bottom: 1rem;
}

/* Responsive width adjustments for indicator */
@media (max-width: 1199px) {
  .indicator {
    width: 80%;
  }
}

@media (max-width: 899px) {
  .indicator {
    width: 90%;
  }
}

@media (max-width: 767px) {
  .indicator {
    width: 95%;
  }
}

@media (max-width: 599px) {
  .indicator {
    width: 98%;
  }
}

@media (max-width: 479px) {
  .indicator {
    width: 99%;
  }
}

.typing-indicator {
  display: inline-flex;
  align-items: flex-end;
  font-size: 1.1rem;
  color: #2F80ED;
  font-weight: 500;
  letter-spacing: 0.5px;
}

.typing-indicator .dot {
  display: inline-block;
  width: 4px;
  height: 4px;
  margin-left: 2px;
  margin-right: 2px;
  border-radius: 50%;
  background: #2F80ED;
  opacity: 0.7;
  animation: typing-jump 1.2s infinite both;
  position: relative;
  bottom: 5px;
}

.typing-indicator .dot:nth-child(2) {
  animation-delay: 0.2s;
}
.typing-indicator .dot:nth-child(3) {
  animation-delay: 0.4s;
}

@keyframes typing-jump {
  0%, 80%, 100% {
    transform: translateY(0);
    opacity: 0.7;
  }
  40% {
    transform: translateY(-8px);
    opacity: 1;
  }
}

.message-actions-row {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  max-width: 1300px;
  width: 60%;
  padding: 0px 0px;
  margin: 0 auto;
}

/* Responsive width adjustments for message actions row */
@media (max-width: 1199px) {
  .message-actions-row {
    width: 80%;
  }
}

@media (max-width: 899px) {
  .message-actions-row {
    width: 90%;
  }
}

@media (max-width: 767px) {
  .message-actions-row {
    width: 95%;
  }
}

@media (max-width: 599px) {
  .message-actions-row {
    width: 98%;
  }
}

@media (max-width: 479px) {
  .message-actions-row {
    width: 99%;
  }
}

.copy-btn, .like-btn, .dislike-btn {
  background: none;
  border: none;
  color: #b0b0b0;
  font-size: 1.1rem;
  cursor: pointer;
  padding: 2px 6px;
  border-radius: 6px;
  transition: background 0.18s, color 0.18s;
  outline: none;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.copy-btn:hover, .like-btn:hover, .dislike-btn:hover,
.copy-btn:focus, .like-btn:focus, .dislike-btn:focus {
  background: #e6f0fa;
  color: #005ea2;
}

.like-btn:disabled, .dislike-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.feedback-thanks {
  color: #005ea2;
  font-size: 0.98rem;
  margin-left: 8px;
  opacity: 0;
  animation: feedback-fadein 0.3s forwards;
  align-self: center;
}

@keyframes feedback-fadein {
  to { opacity: 1; }
}

.copy-btn-wrapper {
  position: relative;
  display: inline-block;
}

.copied-tooltip {
  position: absolute;
  left: 50%;
  top: 120%;
  transform: translateX(-50%) translateY(0);
  background: #005ea2;
  color: #fff;
  padding: 3px 9px;
  border-radius: 6px;
  font-size: 0.75rem;
  font-weight: 500;
  white-space: nowrap;
  pointer-events: none;
  z-index: 10;
  opacity: 0;
  animation: copied-fadeup 1.2s;
}

.tab-btn-content svg {
  width: 20px;
  height: 20px;
  margin-right: 8px;
  margin-bottom: 3px;
  vertical-align: middle;
  display: inline-block;
}

@keyframes copied-fadeup {
  0% {
    opacity: 0;
    transform: translateX(-50%) translateY(-8px);
  }
  20% {
    opacity: 1;
    transform: translateX(-50%) translateY(0);
  }
  80% {
    opacity: 1;
    transform: translateX(-50%) translateY(0);
  }
  100% {
    opacity: 0;
    transform: translateX(-50%) translateY(8px);
  }
}

@keyframes expandDown {
  0% {
    opacity: 0;
    transform: scaleY(0);
    max-height: 0;
  }
  100% {
    opacity: 1;
    transform: scaleY(1);
    max-height: 200px;
  }
}

/* Large Desktop (1400px and above) */
@media (min-width: 1400px) {
  .message, .message.user, .message.ai {
    font-size: 1.2rem;
  }
  
  .input-card {
    width: 70%;
    max-width: 1500px;
  }
  
  .action-buttons {
    width: 70%;
    max-width: 1600px;
  }
  
  .empty-chat-headline {
    font-size: 24px;
  }
}

/* Desktop (1200px - 1399px) */
@media (max-width: 1399px) and (min-width: 1200px) {
  
  .input-card {
    width: 65%;
  }
  
  .action-buttons {
    width: 75%;
  }
}

/* Large Tablet (900px - 1199px) */
@media (max-width: 1199px) and (min-width: 900px) {
  .message, .message.user, .message.ai {
    padding: 16px 16px;
    font-size: 1.05rem;
  }

  .ai-message-wrapper + .message-actions-row {
    width: 45% !important;
  }
  
  .input-area {
    max-width: 85vw;
  }
  
  .input-card {
    width: 80%;
    padding: 16px 24px;
  }
  
  .action-buttons {
    width: 80%;
    gap: 14px;
  }
  
  .action-btn {
    padding: 14px 18px;
    font-size: 0.88rem;
  }
  
  .messages {
    padding: 8px 0 20px 0;
  }
  
  .message-actions-row {
    padding: 16px 16px;
  }
  
  .bot-picker-btn {
    padding: 7px 16px;
    font-size: 0.98rem;
  }
  
  .empty-chat-headline {
    font-size: 18px;
  }
}

/* Tablet (768px - 899px) */
@media (max-width: 899px) and (min-width: 768px) {
  .message, .message.user, .message.ai {
    padding: 14px 14px;
    font-size: 1rem;
  }
  
  .input-area {
    max-width: 90vw;
    margin: 0 auto 0 auto;
    padding: 0 1px;
  }
  
  .chat-input {
    font-size: 1rem;
    padding: 14px 12px;
  }
  
  .send-btn {
    font-size: 1rem;
    padding: 0 16px;
    height: 44px;
  }
  
  .messages {
    padding: 6px 0 18px 0;
    gap: 6px;
    max-width: 99%;
    align-items: center;
    overflow-y: auto;
  }
  
  .bot-picker-btn {
    padding: 6px 12px;
    font-size: 0.95rem;
    margin-right: 4px;
    min-width: 0;
    height: auto;
  }
  
  .message-actions-row {
    gap: 6px;
    font-size: 0.98rem;
    margin-bottom: 12px;
    margin-left: 0px;
    padding: 14px 8vw;
  }
  
  .copy-btn, .like-btn, .dislike-btn {
    font-size: 1rem;
    padding: 2px 4px;
  }
  
  .feedback-thanks {
    font-size: 0.93rem;
    margin-left: 5px;
  }
  
  .empty-chat-headline {
    font-size: 1.5rem;
    margin-top: 7vh;
    margin-bottom: 28px;
  }
  
  .bot-tooltip {
    max-width: 250px;
    font-size: 0.9rem;
    padding: 6px 12px;
    width: 250%;
  }
  
  .input-card {
    padding: 14px 20px;
  }
  
  .action-buttons {
    width: 90%;
    gap: 12px;
  }
  
  .action-btn {
    padding: 12px 16px;
    font-size: 0.85rem;
  }
}

/* Large Mobile (600px - 767px) */
@media (max-width: 767px) and (min-width: 600px) {
  .message, .message.user, .message.ai {
    padding: 12px 4vw;
    font-size: 0.98rem;
  }
  
  .message-actions-row {
    padding: 12px 4vw;
    font-size: 0.95rem;
  }
  
  .input-area {
    max-width: 92vw;
    padding: 0 2px;
  }
  
  .chat-input {
    font-size: 0.98rem;
    padding: 12px 10px;
  }
  
  .send-btn {
    font-size: 0.98rem;
    padding: 0 12px;
    height: 42px;
  }
  
  .messages {
    padding: 6px 0 16px 0;
  }
  
  .bot-picker-btn {
    padding: 5px 10px;
    font-size: 0.92rem;
  }
  
  .bot-picker-row {
    gap: 8px;
    flex-wrap: wrap;
  }
  
  .message-actions-row {
    gap: 5px;
    font-size: 0.95rem;
    padding: 12px 4vw;
  }
  
  .copy-btn, .like-btn, .dislike-btn {
    font-size: 0.97rem;
    padding: 2px 3px;
  }
  
  .empty-chat-headline {
    font-size: 1.3rem;
    margin-top: 6vh;
  }
  
  .input-card {
    padding: 12px 16px;
  }
  
  .action-buttons {
    width: 95%;
    gap: 10px;
  }
  
  .action-btn {
    padding: 11px 14px;
    font-size: 0.82rem;
  }
}

/* Mobile (480px - 599px) */
@media (max-width: 599px) and (min-width: 480px) {
  .message, .message.user, .message.ai {
    padding: 12px 3vw;
    font-size: 0.97rem;
  }
  
  .message-actions-row {
    padding: 12px 3vw;
    font-size: 0.93rem;
  }
  
  .input-area {
    max-width: 90vw;
    margin: 0 auto 0 auto;
    padding: 0 0.5px;
  }
  
  .chat-input {
    font-size: 0.97rem;
    padding: 10px 8px;
    margin-right: 6px;
  }
  
  .send-btn {
    font-size: 0.97rem;
    padding: 0 10px;
    height: 40px;
  }
  
  .messages {
    padding: 6px 0 18px 0;
    align-items: center;
    width: 99%;
  }
  
  .bot-picker-btn {
    padding: 4px 8px;
    font-size: 0.91rem;
    margin-right: 2px;
    min-width: 0;
    height: auto;
  }
  
  .bot-picker-row {
    padding: 10px 8px 0 8px;
    gap: 6px;
    flex-wrap: wrap;
  }
  
  .message-actions-row {
    gap: 4px;
    font-size: 0.93rem;
    margin-bottom: 8px;
    margin-left: auto;
    margin-right: auto;
    padding: 0!important;
    max-width: 90vw;
  }
  
  .copy-btn, .like-btn, .dislike-btn {
    font-size: 0.95rem;
    padding: 1px 2px;
  }
  
  .feedback-thanks {
    font-size: 0.9rem;
    margin-left: 3px;
  }
  
  .empty-chat-headline {
    font-size: 1.15rem;
    margin-top: 4vh;
    margin-bottom: 18px;
  }
  
  .bot-tooltip {
    max-width: 250px;
    font-size: 0.75rem;
    padding: 5px 10px;
    top: 110%;
    width: 150%;
  }
  
  .input-card {
    padding: 10px 12px;
  }
  
  .action-buttons {
    width: 98%;
    gap: 8px;
  }
  
  .action-btn {
    padding: 10px 12px;
    font-size: 0.8rem;
  }
}

/* Small Mobile (320px - 479px) */
@media (max-width: 479px) and (min-width: 320px) {
  .message, .message.user, .message.ai {
    padding: 10px 2vw;
    font-size: 0.95rem;
  }
  
  .message-actions-row {
    padding: 10px 2vw;
    font-size: 0.9rem;
  }
  
  .input-area {
    max-width: 88vw;
    padding: 0 1px;
  }
  
  .chat-input {
    font-size: 0.95rem;
    padding: 8px 6px;
    margin-right: 4px;
  }
  
  .send-btn {
    font-size: 0.95rem;
    padding: 0 8px;
    height: 38px;
  }
  
  .messages {
    padding: 4px 0 14px 0;
  }
  
  .bot-picker-btn {
    padding: 3px 6px;
    font-size: 0.88rem;
    margin-right: 1px;
  }
  
  .bot-picker-row {
    padding: 8px 6px 0 6px;
    gap: 4px;
  }
  
  .message-actions-row {
    gap: 3px;
    font-size: 0.9rem;
    padding: 10px 2vw;
  }
  
  .copy-btn, .like-btn, .dislike-btn {
    font-size: 0.92rem;
    padding: 1px 1px;
  }
  
  .empty-chat-headline {
    font-size: 1rem;
    margin-top: 3vh;
    margin-bottom: 16px;
  }
  
  .input-card {
    padding: 8px 10px;
  }
  
  .action-buttons {
    width: 100%;
    gap: 6px;
  }
  
  .action-btn {
    padding: 8px 10px;
    font-size: 0.78rem;
    min-height: 60px;
  }
  
  .action-btn span {
    font-size: 0.72rem;
  }
  
  .example-item {
    padding: 6px 10px;
    font-size: 0.72rem;
  }
}

/* Extra Small Mobile (below 320px) */
@media (max-width: 319px) {
  .message, .message.user, .message.ai {
    padding: 8px 1vw;
    font-size: 0.9rem;
  }
  
  .message-actions-row {
    padding: 8px 1vw;
    font-size: 0.85rem;
  }
  
  .input-area {
    max-width: 85vw;
  }
  
  .chat-input {
    font-size: 0.9rem;
    padding: 6px 4px;
  }
  
  .send-btn {
    font-size: 0.9rem;
    height: 36px;
  }
  
  .bot-picker-btn {
    padding: 2px 4px;
    font-size: 0.85rem;
  }
  
  .empty-chat-headline {
    font-size: 0.9rem;
    margin-top: 2vh;
  }
  
  .input-card {
    padding: 6px 8px;
  }
  
  .action-btn {
    padding: 6px 8px;
    font-size: 0.75rem;
    min-height: 50px;
  }
  
  .action-btn span {
    font-size: 0.7rem;
  }
  
  .example-item {
    padding: 4px 8px;
    font-size: 0.7rem;
  }
}

/* Landscape orientation adjustments for mobile */
@media (max-width: 900px) and (orientation: landscape) {
  .empty-center-wrapper {
    min-height: 70vh;
    padding-top: 10vh;
  }
  
  .empty-chat-headline {
    font-size: 1.2rem;
    margin-top: 2vh;
    margin-bottom: 12px;
  }
  
  .bot-picker-row {
    margin-top: 16px;
    margin-bottom: 12px;
  }
  
  .messages {
    padding: 4px 0 12px 0;
  }
  
  .input-area.with-messages {
    margin-top: 8px;
    margin-bottom: 8px;
  }
}

/* High DPI displays */
@media (min-resolution: 192dpi) {
  .chat-input, .send-btn, .bot-picker-btn, .action-btn {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
}

/* Reduced motion for accessibility */
@media (prefers-reduced-motion: reduce) {
  .chat-area,
  .message,
  .input-area,
  .chat-input,
  .send-btn,
  .bot-picker-btn,
  .action-btn,
  .typing-indicator .dot,
  .expanded-examples {
    transition: none;
    animation: none;
  }
  
  .typing-indicator .dot {
    animation: none;
  }
}

/* Markdown formatting styles */
.markdown-content {
  width: 100%;
}

.markdown-paragraph {
  margin-bottom: 0px;
  line-height: 1.5;
  font-size: 16px;
}

.markdown-heading {
  margin-top: 18px;
  margin-bottom: 16px;
  font-weight: 600;
  line-height: 1.25;
}

.markdown-heading:first-child {
  margin-top: 0;
}

h1.markdown-heading {
  font-size: 19px;
}

h2.markdown-heading {
  font-size: 18px;
}

h3.markdown-heading {
  font-size: 17px;
}

.markdown-list, .markdown-ordered-list {
  margin-bottom: 16px;
  padding-left: 2em;
  font-size: 16px;
}

.markdown-list-item {
  margin-bottom: 6px;
}

.markdown-divider {
  height: 0.25em;
  margin: 24px 0;
  background-color: rgba(0, 0, 0, 0.1);
  border: 0;
}

.markdown-blockquote {
  padding: 0 1em;
  margin-left: 0;
  margin-right: 0;
  color: #6a737d;
  border-left: 0.25em solid #dfe2e5;
}

.markdown-code-block {
  padding: 16px;
  overflow: auto;
  font-size: 85%;
  line-height: 1.45;
  background-color: #f6f8fa;
  border-radius: 3px;
  margin-bottom: 16px;
  white-space: pre-wrap;
}

/* Dark theme adjustments */
.message.ai .markdown-code-block {
  background-color: #2d333b;
  color: #e6edf3;
}

.message.ai .markdown-blockquote {
  border-left-color: #444c56;
  color: #adbac7;
}

.message.ai .markdown-divider {
  background-color: rgba(255, 255, 255, 0.1);
}

/* Add styles for message actions alignment */
.message.user + .message-actions-row {
  justify-content: end;
}

.ai-message-wrapper + .message-actions-row {
  justify-content: center;
  width: 55%;
  margin-left: 0px; /* Align with AI message content (avatar width + gap) */
}

.input-card {
  background: #F9F9F9;
  border: 1px solid #D5D5D5;
  border-radius: 24px;
  box-shadow: 0 2px 16px rgba(23,32,43,0.06);
  padding: 12px 32px 12px 32px;
  width: 60%;
  max-width: 1300px;
  margin: 0 auto 0 auto;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  position: relative;
  z-index: 2;
}

/* Responsive width adjustments for input card */
@media (max-width: 1199px) {
  .input-card {
    width: 80%;
  }
}

@media (max-width: 899px) {
  .input-card {
    width: 90%;
  }
}

@media (max-width: 767px) {
  .input-card {
    width: 95%;
  }
}

@media (max-width: 599px) {
  .input-card {
    width: 98%;
  }
}

@media (max-width: 479px) {
  .input-card {
    width: 99%;
  }
}

.tab-buttons {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 12px;
  margin-bottom: 18px;
  margin-top: 18px;
}

.tab-btn {
  background: #fff;
  color: #878787;
  border: none;
  border-radius: 10px;
  padding: 8px 22px;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.18s, color 0.18s, box-shadow 0.18s;
  outline: none;
  box-shadow: 0 1px 4px rgba(23,32,43,0.04);
}

.tab-btn.active {
  background: #2654FF1A;
  color: #132775;
  font-weight: 400;
  box-shadow: 0 4px 16px rgba(47,128,237,0.10);
}

.tab-btn:hover {
  background: #2654FF1A;
  color: #132775;
  font-weight: 400;
  box-shadow: 0 4px 16px rgba(47,128,237,0.10);
}

.input-row {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
}

.input-card .chat-input {
  flex: 1 1;
  padding: 18px 0px;
  border-radius: 18px;
  border: none !important;
  background: #F9F9F9;
  color: #686868;
  font-size: 16px;
  font-weight: 700;
  font-family: 'Gilroy', sans-serif;
  outline: none;
  transition: border 0.2s, box-shadow 0.2s;
  box-shadow: none !important;
  min-width: 0;
}

.input-card .chat-input::placeholder {
  color: #AEAEAE;
  font-weight: 400;
  font-size: 16px;
  padding: 0;
}

.input-card .chat-input:focus {
  background: #F9F9F9;
}

.send-btn {
  background: #2654FF1A;
  color:#132775;
  border: none;
  border-radius: 50%;
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.2rem;
  cursor: pointer;
  transition: background 0.2s, color 0.2s, box-shadow 0.2s;
  box-shadow: 0 2px 8px rgba(23,32,43,0.06);
}

.send-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.send-btn:hover:not(:disabled), .send-btn:focus:not(:disabled) {
  background: #132775;
  color: #fff;
  box-shadow: 0 4px 16px rgba(47,128,237,0.10);
}

/* Medium Tablet and below (700px and below) - Enhanced responsive design */
@media (max-width: 700px) {
  .input-card {
    padding: 18px 8px 14px 8px;
  }
  
  .tab-buttons {
    gap: 6px;
    margin-bottom: 10px;
  }
  
  .input-card .chat-input {
    padding: 14px 10px;
    font-size: 1rem;
  }
  
  .send-btn {
    width: 40px;
    height: 40px;
    font-size: 1rem;
  }
  
  .action-buttons {
    width: 95%;
    gap: 10px;
    margin-top: 18px;
    margin-bottom: 10px;
  }
  
  .action-btn {
    padding: 12px 14px;
    font-size: 0.83rem;
    min-height: 65px;
  }
  
  .action-btn span {
    font-size: 0.78rem;
  }
  
  .example-item {
    padding: 9px 14px;
    font-size: 0.78rem;
  }
  
  .message, .message.user, .message.ai {
    padding: 13px 6vw;
    font-size: 0.99rem;
  }
  
  .message-actions-row {
    padding: 13px 6vw;
  }
  
  .input-area {
    max-width: 92vw;
  }
  
  .chat-input {
    font-size: 0.99rem;
    padding: 12px 10px;
  }
  
  .bot-picker-btn {
    padding: 6px 11px;
    font-size: 0.93rem;
  }
  
  .empty-chat-headline {
    font-size: 1.4rem;
    margin-top: 6vh;
  }
}

.action-buttons {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  gap: 16px;
  margin-top: 24px;
  margin-bottom: 16px;
  width: 78%;
  max-width: 1400px;
  margin-left: auto;
  margin-right: auto;
  overflow: visible;
  transition: all 0.6s cubic-bezier(0.4, 0, 0.2, 1);
  opacity: 1;
  transform: translateY(0);
}

.action-buttons.fading {
  opacity: 0;
  transform: translateY(-10px);
}

.action-buttons:not(.expanded) {
  align-content:baseline; 
}

.action-btn {
  background: #fff;
  border: 1px solid #D5D5D5;
  border-radius: 12px;
  padding: 16px 20px;
  font-size: 0.9rem;
  font-weight: 500;
  color: #AEAEAE;
  cursor: pointer;
  transition: background 0.3s ease, border 0.3s ease, box-shadow 0.3s ease, scale 0.3s ease, border-radius 0.3s ease;
  outline: none;
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1 1;
  min-height: 70px;
  width: 100%;
  text-align: left;
  line-height: 1.4;
  box-shadow: 0 2px 8px rgba(23,32,43,0.04);
}

.action-btn.expanded {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  border-bottom: 1px solid #F0F0F0;
}

.action-btn:hover {
  box-shadow: 0 8px 32px rgba(23,32,43,0.08);
}

.action-btn span {
  flex: 1 1;
  font-size: 0.85rem;
  line-height: 1.3;
}

.action-btn svg {
  color: #132876;
}

.action-btn-container {
  position: relative;
  flex: 1 1;
  max-width: 78%;
  overflow: visible;
  display: flex;
  flex-direction: column;
}

.dropdown-arrow {
  transition: transform 0.3s ease;
  color: #AEAEAE;
  flex-shrink: 0;
}

.dropdown-arrow.rotated {
  transform: rotate(180deg);
}

.expanded-examples {
  width: 100%;
  background: #fff;
  border-right: 1px solid #D5D5D5;
  border-left: 1px solid #D5D5D5;
  border-bottom: 1px solid #D5D5D5;
  border-radius: 0 0 12px 12px;
  overflow: hidden;
  margin-top: 0;
  position: static;
  box-shadow: 0 4px 16px rgba(23,32,43,0.08);
  animation: expandDown 0.3s ease-out;
  transform-origin: top;
}

.example-item {
  width: 100%;
  padding: 12px 20px;
  background: none;
  border: none;
  text-align: left;
  font-size: 0.9rem;
  color: #AEAEAE;
  cursor: pointer;
  transition: background 0.3s ease, color 0.3s ease, transform 0.2s ease;
  border-bottom: 1px solid #F0F0F0;
  line-height: 1.4;
}

.example-item:last-child {
  border-bottom: none;
}

.example-item:hover {
  color: #132775;
  transform: translateX(4px);
}

.example-item:focus {
  color: #132775;
  outline: none;
  transform: translateX(4px);
}

.example-item:active {
  color: #132775;
  transform: translateX(4px) scale(0.98);
}

/* Tablet and below (900px and below) - Action buttons responsive design */
@media (max-width: 900px) {
  .action-buttons {
    gap: 12px;
    margin-top: 20px;
    margin-bottom: 12px;
    padding: 0 16px;
    width: 90%;
  }
  
  .action-btn {
    padding: 12px 16px;
    font-size: 0.85rem;
    max-width: 180px;
    min-height: 68px;
  }
  
  .action-btn span {
    font-size: 0.8rem;
  }
  
  .expanded-examples {
    margin-top: 0;
  }
  
  .example-item {
    padding: 10px 16px;
    font-size: 0.8rem;
  }
  
  .action-btn-container {
    max-width: 90%;
  }
}

/* Mobile and below (600px and below) - Enhanced responsive design */
@media (max-width: 600px) {
  .action-buttons {
    flex-direction: column;
    gap: 8px;
    margin-top: 16px;
    margin-bottom: 8px;
    padding: 0 8px;
  }
  
  .action-btn {
    padding: 10px 14px;
    font-size: 0.8rem;
    max-width: 100%;
    width: 100%;
  }
  
  .action-btn span {
    font-size: 0.75rem;
  }
  
  .expanded-examples {
    margin-top: 0;
  }
  
  .example-item {
    padding: 8px 14px;
    font-size: 0.75rem;
  }
  
  /* Additional mobile optimizations */
  .input-card {
    padding: 12px 16px;
  }
  
  .tab-buttons {
    gap: 4px;
    margin-bottom: 8px;
  }
  
  .tab-btn {
    padding: 6px 12px;
    font-size: 0.9rem;
  }
  
  .input-card .chat-input {
    padding: 12px 8px;
    font-size: 0.95rem;
  }
  
  .send-btn {
    width: 38px;
    height: 38px;
    font-size: 0.95rem;
  }
  
  .message, .message.user, .message.ai {
    padding: 12px 12px;
    font-size: 0.96rem;
  }
  
  .message-actions-row {
    padding: 12px 3vw;
  }
  
  .input-area {
    max-width: 92vw;
    padding: 0 2px;
  }
  
  .chat-input {
    font-size: 0.96rem;
    padding: 10px 8px;
  }
  
  .messages {
    padding: 6px 0 16px 0;
  }
  
  .bot-picker-btn {
    padding: 5px 10px;
    font-size: 0.9rem;
  }
  
  .message-actions-row {
    gap: 4px;
    font-size: 0.94rem;
    padding: 12px 3vw;
  }
  
  .copy-btn, .like-btn, .dislike-btn {
    font-size: 0.94rem;
    padding: 2px 3px;
  }
  
  .empty-chat-headline {
    font-size: 1.2rem;
    margin-top: 5vh;
  }
}

/* Touch device optimizations */
@media (hover: none) and (pointer: coarse) {
  .copy-btn, .like-btn, .dislike-btn {
    min-height: 44px;
    min-width: 44px;
    padding: 8px 12px;
  }
  
  .bot-picker-btn {
    min-height: 44px;
    padding: 8px 16px;
  }
  
  .send-btn {
    min-height: 44px;
    min-width: 44px;
  }
  
  .action-btn {
    min-height: 60px;
  }
  
  .tab-btn {
    min-height: 44px;
    padding: 10px 20px;
  }
  
  .example-item {
    min-height: 44px;
    padding: 12px 20px;
  }
}

/* High contrast mode support */
@media (prefers-contrast: high) {
  .message.user {
    border: 2px solid #17202B;
  }
  
  .chat-input {
    border: 2px solid #17202B;
  }
  
  .send-btn {
    border: 2px solid #132775;
  }
  
  .action-btn {
    border: 2px solid #D5D5D5;
  }
  
  .bot-picker-btn {
    border: 2px solid #2F80ED;
  }
}

/* Print styles */
@media print {
  .chat-area {
    background: white !important;
    color: black !important;
  }
  
  .input-area,
  .send-btn,
  .action-buttons,
  .bot-picker-row {
    display: none !important;
  }
  
  .message {
    break-inside: avoid;
    page-break-inside: avoid;
  }
}

/* Focus visible for better accessibility */
.copy-btn:focus-visible,
.like-btn:focus-visible,
.dislike-btn:focus-visible,
.send-btn:focus-visible,
.bot-picker-btn:focus-visible,
.action-btn:focus-visible,
.tab-btn:focus-visible,
.example-item:focus-visible {
  outline: 2px solid #2F80ED;
  outline-offset: 2px;
}

/* Improved scrolling for mobile */
@media (max-width: 900px) {
  .messages {
    -webkit-overflow-scrolling: touch;
    scroll-behavior: smooth;
  }
  
  .chat-input {
    -webkit-appearance: none;
    border-radius: 24px;
  }
  
  .send-btn {
    -webkit-tap-highlight-color: transparent;
  }
}

/* Landscape phone optimizations */
@media (max-width: 900px) and (orientation: landscape) and (max-height: 500px) {
  .empty-center-wrapper {
    min-height: 60vh;
    padding-top: 5vh;
  }
  
  .empty-chat-headline {
    font-size: 1rem;
    margin-top: 2vh;
    margin-bottom: 8px;
  }
  
  .bot-picker-row {
    margin-top: 8px;
    margin-bottom: 8px;
  }
  
  .messages {
    padding: 2px 0 8px 0;
  }
  
  .input-area.with-messages {
    margin-top: 4px;
    margin-bottom: 4px;
  }
  
  .action-buttons {
    margin-top: 8px;
    margin-bottom: 6px;
  }
  
  .action-btn {
    min-height: 50px;
    padding: 8px 12px;
  }
}

/* Ultra-wide screen support */
@media (min-width: 2000px) {
  .message, .message.user, .message.ai {
    max-width: 1300px;
    font-size: 1.3rem;
  }
  
  .input-card {
    width: 60%;
    max-width: 1600px;
  }
  
  .action-buttons {
    width: 60%;
    max-width: 1800px;
  }
  
  .empty-chat-headline {
    font-size: 28px;
  }
  
  .bot-picker-btn {
    font-size: 1.1rem;
    padding: 10px 24px;
  }
  
  .chat-input {
    font-size: 1.2rem;
    padding: 24px 0px;
  }
  
  .send-btn {
    width: 56px;
    height: 56px;
    font-size: 1.4rem;
  }
}

.ai-message-row {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}

.ai-message-wrapper {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 16px;
  justify-content: flex-start;
  width: 60%;
  max-width: 1300px;
  margin-left: auto;
  margin-right: auto;
}

/* Responsive width adjustments for AI message wrapper */
@media (max-width: 1199px) {
  .ai-message-wrapper {
    width: 80%;
  }
}

@media (max-width: 899px) {
  .ai-message-wrapper {
    width: 90%;
  }
}

@media (max-width: 767px) {
  .ai-message-wrapper {
    width: 95%;
  }
}

@media (max-width: 599px) {
  .ai-message-wrapper {
    width: 98%;
  }
}

@media (max-width: 479px) {
  .ai-message-wrapper {
    width: 99%;
  }
}

.ai-avatar-wrapper{
  width: 45px;
  height: 45px;
  background: #2654FF1A;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 8px;
  flex-shrink: 0;
}

.ai-avatar{
  width: 20px;
  height: 20px;
  object-fit: contain;
}

/* Responsive avatar adjustments */
@media (max-width: 1199px) {
  .ai-avatar-wrapper {
    width: 42px;
    height: 42px;
  }
  
  .ai-avatar {
    width: 18px;
    height: 18px;
  }
}

@media (max-width: 899px) {
  .ai-avatar-wrapper {
    width: 40px;
    height: 40px;
  }
  
  .ai-avatar {
    width: 17px;
    height: 17px;
  }
}

@media (max-width: 767px) {
  .ai-avatar-wrapper {
    width: 38px;
    height: 38px;
  }
  
  .ai-avatar {
    width: 16px;
    height: 16px;
  }
}

@media (max-width: 599px) {
  .ai-avatar-wrapper {
    width: 36px;
    height: 36px;
  }
  
  .ai-avatar {
    width: 15px;
    height: 15px;
  }
}

@media (max-width: 479px) {
  .ai-avatar-wrapper {
    width: 34px;
    height: 34px;
  }
  
  .ai-avatar {
    width: 14px;
    height: 14px;
  }
}

@media (max-width: 319px) {
  .ai-avatar-wrapper {
    width: 32px;
    height: 32px;
  }
  
  .ai-avatar {
    width: 13px;
    height: 13px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/ChatArea/ChatArea.css"],"names":[],"mappings":"AAAA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,iDAAiD;EACjD,mBAAmB;EACnB,qBAAqB,EAAE,YAAY;EACnC,wBAAwB,EAAE,0BAA0B;AACtD;;AAEA,8DAA8D;AAC9D;EACE,aAAa;AACf;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,UAAU;EACV,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,iDAAiD;EACjD,wBAAwB;EACxB,UAAU;AACZ;;AAEA,8CAA8C;AAC9C;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE,2BAA2B;EAC3B,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;EACpB,cAAc;EACd,aAAa;EACb,yBAAyB;EACzB,gBAAgB,EAAE,sCAAsC;EACxD,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,oBAAoB;EACpB,yBAAyB;AAC3B;;AAEA;;EAEE,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,UAAU;EACV,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,sCAAsC;EACtC,kBAAkB;EAClB,sBAAsB;EACtB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,WAAW;EACX,iDAAiD;EACjD,wBAAwB;EACxB,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,wBAAwB;EACxB,UAAU;AACZ;;AAEA;EACE,2BAA2B;EAC3B,YAAY;AACd;;AAEA;EACE,SAAO;EACP,iBAAiB;EACjB,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,wCAAwC;EACxC,yCAAyC;EACzC,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,yDAA4C;EAC5C,wBAAwB;EACxB,2BAA2B;EAC3B,4BAA4B;EAC5B,iBAAiB;EACjB,iDAAiD;EACjD,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,UAAU;EACV,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,sBAAsB;EACtB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,iDAAiD;EACjD,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,UAAU;EACV,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,oBAAoB;EACpB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,2DAA2D;EAC3D,yCAAyC;EACzC,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,2CAA2C;AAC7C;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,iBAAiB;EACjB,4CAA4C;AAC9C;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,WAAW;EACX,yCAAyC;EACzC,2CAA2C;EAC3C,gBAAgB;EAChB,WAAW;EACX,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,UAAU;EACV,iBAAiB;EACjB,cAAc;AAChB;;AAEA,qDAAqD;AACrD;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;IACV,eAAe;EACjB;AACF;;AAEA;EACE;IACE,UAAU;IACV,eAAe;EACjB;AACF;;AAEA;EACE;IACE,UAAU;IACV,eAAe;EACjB;AACF;;AAEA;EACE;IACE,UAAU;IACV,eAAe;EACjB;AACF;;AAEA;EACE;IACE,WAAW;IACX,cAAc;EAChB;AACF;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA,+CAA+C;AAC/C;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,yCAAyC;EACzC,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;;AAEA;EACE;IACE,wBAAwB;IACxB,YAAY;EACd;EACA;IACE,2BAA2B;IAC3B,UAAU;EACZ;AACF;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,iBAAiB;EACjB,UAAU;EACV,gBAAgB;EAChB,cAAc;AAChB;;AAEA,yDAAyD;AACzD;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,yCAAyC;EACzC,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;EACV,wCAAwC;EACxC,kBAAkB;AACpB;;AAEA;EACE,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,yCAAyC;EACzC,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,WAAW;EACX,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE;IACE,UAAU;IACV,4CAA4C;EAC9C;EACA;IACE,UAAU;IACV,yCAAyC;EAC3C;EACA;IACE,UAAU;IACV,yCAAyC;EAC3C;EACA;IACE,UAAU;IACV,2CAA2C;EAC7C;AACF;;AAEA;EACE;IACE,UAAU;IACV,oBAAoB;IACpB,aAAa;EACf;EACA;IACE,UAAU;IACV,oBAAoB;IACpB,iBAAiB;EACnB;AACF;;AAEA,qCAAqC;AACrC;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,UAAU;IACV,iBAAiB;EACnB;;EAEA;IACE,UAAU;IACV,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,8BAA8B;AAC9B;;EAEE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA,kCAAkC;AAClC;EACE;IACE,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,UAAU;IACV,kBAAkB;EACpB;;EAEA;IACE,UAAU;IACV,SAAS;EACX;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,2BAA2B;AAC3B;EACE;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,qBAAqB;IACrB,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,eAAe;IACf,YAAY;EACd;;EAEA;IACE,qBAAqB;IACrB,QAAQ;IACR,cAAc;IACd,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,QAAQ;IACR,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;IACjB,WAAW;EACb;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,UAAU;IACV,SAAS;EACX;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;EACpB;AACF;;AAEA,iCAAiC;AACjC;EACE;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,YAAY;EACd;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,QAAQ;IACR,eAAe;EACjB;;EAEA;IACE,QAAQ;IACR,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,UAAU;IACV,SAAS;EACX;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;EACpB;AACF;;AAEA,2BAA2B;AAC3B;EACE;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,qBAAqB;IACrB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,YAAY;EACd;;EAEA;IACE,qBAAqB;IACrB,mBAAmB;IACnB,UAAU;EACZ;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,uBAAuB;IACvB,QAAQ;IACR,eAAe;EACjB;;EAEA;IACE,QAAQ;IACR,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,SAAS;IACT,WAAW;EACb;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,UAAU;IACV,QAAQ;EACV;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;EACnB;AACF;;AAEA,iCAAiC;AACjC;EACE;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,YAAY;EACd;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,QAAQ;IACR,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,QAAQ;EACV;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;AACF;;AAEA,qCAAqC;AACrC;EACE;IACE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,YAAY;EACd;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;AACF;;AAEA,iDAAiD;AACjD;EACE;IACE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;AACF;;AAEA,sBAAsB;AACtB;EACE;IACE,mCAAmC;IACnC,kCAAkC;EACpC;AACF;;AAEA,qCAAqC;AACrC;EACE;;;;;;;;;IASE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,+BAA+B;AAC/B;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,oCAAoC;EACpC,SAAS;AACX;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,cAAc;EACd,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,cAAc;EACd,cAAc;EACd,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,2BAA2B;AAC3B;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA,6CAA6C;AAC7C;EACE,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;EACvB,UAAU;EACV,gBAAgB,EAAE,uDAAuD;AAC3E;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,0CAA0C;EAC1C,4BAA4B;EAC5B,UAAU;EACV,iBAAiB;EACjB,qBAAqB;EACrB,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,kBAAkB;EAClB,UAAU;AACZ;;AAEA,gDAAgD;AAChD;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,2DAA2D;EAC3D,aAAa;EACb,yCAAyC;AAC3C;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,gBAAgB;EAChB,4CAA4C;AAC9C;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,gBAAgB;EAChB,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,SAAO;EACP,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iCAAiC;EACjC,aAAa;EACb,wCAAwC;EACxC,2BAA2B;EAC3B,YAAY;AACd;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,eAAe;EACf,wDAAwD;EACxD,yCAAyC;AAC3C;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,4CAA4C;AAC9C;;AAEA,2EAA2E;AAC3E;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,QAAQ;IACR,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,UAAU;IACV,SAAS;IACT,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;AACF;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,SAAS;EACT,gBAAgB;EAChB,mBAAmB;EACnB,UAAU;EACV,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,iDAAiD;EACjD,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,UAAU;EACV,4BAA4B;AAC9B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kHAAkH;EAClH,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,SAAO;EACP,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,4BAA4B;EAC5B,6BAA6B;EAC7B,gCAAgC;AAClC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,SAAO;EACP,cAAc;EACd,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,+BAA+B;EAC/B,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,+BAA+B;EAC/B,8BAA8B;EAC9B,gCAAgC;EAChC,4BAA4B;EAC5B,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,0CAA0C;EAC1C,mCAAmC;EACnC,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,sEAAsE;EACtE,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,sCAAsC;AACxC;;AAEA,0EAA0E;AAC1E;EACE;IACE,SAAS;IACT,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA,oEAAoE;AACpE;EACE;IACE,sBAAsB;IACtB,QAAQ;IACR,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,WAAW;EACb;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA,oCAAoC;EACpC;IACE,kBAAkB;EACpB;;EAEA;IACE,QAAQ;IACR,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,QAAQ;IACR,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;AACF;;AAEA,+BAA+B;AAC/B;EACE;IACE,gBAAgB;IAChB,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;AACF;;AAEA,+BAA+B;AAC/B;EACE;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA,iBAAiB;AACjB;EACE;IACE,4BAA4B;IAC5B,uBAAuB;EACzB;;EAEA;;;;IAIE,wBAAwB;EAC1B;;EAEA;IACE,mBAAmB;IACnB,wBAAwB;EAC1B;AACF;;AAEA,2CAA2C;AAC3C;;;;;;;;EAQE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA,kCAAkC;AAClC;EACE;IACE,iCAAiC;IACjC,uBAAuB;EACzB;;EAEA;IACE,wBAAwB;IACxB,mBAAmB;EACrB;;EAEA;IACE,wCAAwC;EAC1C;AACF;;AAEA,kCAAkC;AAClC;EACE;IACE,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;AACF;;AAEA,8BAA8B;AAC9B;EACE;IACE,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,UAAU;IACV,iBAAiB;EACnB;;EAEA;IACE,UAAU;IACV,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;AACF;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,2BAA2B;EAC3B,UAAU;EACV,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,wDAAwD;AACxD;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA,kCAAkC;AAClC;EACE;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF","sourcesContent":[".chat-area {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  background: #fff;\n  min-width: 0;\n  position: relative;\n  transition: all 0.3s ease-in-out;\n}\n\n.messages {\n  flex: 1;\n  overflow-y: auto;\n  padding: 32px 0 50px 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 100%;\n  position: relative;\n  height: 70vh;\n  max-height: 100%;\n  scroll-behavior: smooth;\n  transition: all 0.6s cubic-bezier(0.4, 0, 0.2, 1);\n  /* Hide scrollbar */\n  scrollbar-width: none; /* Firefox */\n  -ms-overflow-style: none; /* Internet Explorer 10+ */\n}\n\n/* Hide scrollbar for WebKit browsers (Chrome, Safari, Edge) */\n.messages::-webkit-scrollbar {\n  display: none;\n}\n\n.messages.with-content {\n  padding: 16px 0 50px 0;\n}\n\n.message {\n  max-width: 1300px;\n  width: 60%;\n  font-size: 1.1rem;\n  line-height: 1.6;\n  word-break: break-word;\n  display: block;\n  box-shadow: none;\n  border: none;\n  padding: 0;\n  background: none;\n  color: #17202B;\n  margin-left: auto;\n  margin-right: auto;\n  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);\n  transform: translateY(0);\n  opacity: 1;\n}\n\n/* Responsive width adjustments for messages */\n@media (max-width: 1199px) {\n  .message, .message.user, .message.ai {\n    width: 80%;\n  }\n}\n\n@media (max-width: 899px) {\n  .message, .message.user, .message.ai {\n    width: 90%;\n  }\n}\n\n@media (max-width: 767px) {\n  .message, .message.user, .message.ai {\n    width: 95%;\n  }\n}\n\n@media (max-width: 599px) {\n  .message, .message.user, .message.ai {\n    width: 98%;\n  }\n}\n\n@media (max-width: 479px) {\n  .message, .message.user, .message.ai {\n    width: 99%;\n  }\n}\n\n.message.entering {\n  transform: translateY(20px);\n  opacity: 0;\n}\n\n.message.user {\n  border-radius: 15px;\n  padding: 10px 0px;\n  margin-top: 8px;\n  margin-bottom: 4px;\n  padding-top: 14px;\n  padding-bottom: 14px;\n  color: #17202B;\n  display: flex;\n  justify-content: flex-end;\n  margin-left: 0px; /* leave space on left for AI avatar */\n  margin-right: 0;\n}\n\n.user-message-content {\n  text-align: right;\n  font-size: 16px;\n  color: #17202B;\n  border-radius: 15px;\n  max-width: 520px;\n  min-width: 0;\n  align-self: flex-end;\n  width: fit-content;\n  margin-left: auto;\n  padding: 18px 18px;\n  border: 1px solid #D5D5D5;\n}\n\n.message.user .copy-btn {\n  opacity: 0;\n  pointer-events: none;\n  transition: opacity 0.18s;\n}\n\n.message.user:hover .copy-btn,\n.message.user:focus-within .copy-btn {\n  opacity: 1;\n  pointer-events: auto;\n}\n\n.message.ai {\n  background: none;\n  border-radius: 23px;\n  box-shadow: none;\n  padding: 10px 28px;\n  margin-top: 8px;\n  color: #17202B;\n  max-width: 1300px;\n  width: 60%;\n  margin-left: 0;\n  margin-right: 0;\n  text-align: left;\n  background: #fff;\n  color: #222;\n  border-radius: 15px;\n  padding: 18px 18px;\n  min-width: 0;\n  box-shadow: 0 1px 4px rgba(0,0,0,0.04);\n  margin-bottom: 4px;\n  align-self: flex-start;\n  display: block;\n  width: fit-content;\n}\n\n.input-area {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 0;\n  background: none;\n  border: none;\n  box-shadow: none;\n  margin: 0 auto 0px auto;\n  max-width: 600px;\n  width: 100%;\n  transition: all 0.6s cubic-bezier(0.4, 0, 0.2, 1);\n  transform: translateY(0);\n  opacity: 1;\n}\n\n.input-area {\n  margin-top: 0;\n}\n\n.input-area.with-messages {\n  margin-top: 16px;\n  margin-bottom: 16px;\n  transform: translateY(0);\n  opacity: 1;\n}\n\n.input-area.initial-state {\n  transform: translateY(20px);\n  opacity: 0.8;\n}\n\n.chat-input {\n  flex: 1;\n  padding: 22px 0px;\n  border-radius: 24px;\n  border: 1.5px solid #EEECF9;\n  background: #EEECF9;\n  color: #686868;\n  font-size: 1.08rem;\n  margin-right: 12px;\n  outline: none;\n  transition: border 0.2s, box-shadow 0.2s;\n  box-shadow: 0 2px 8px rgba(23,32,43,0.06);\n  min-width: 0;\n}\n\n.chat-input:focus {\n  border: 1.5px solid #2F80ED;\n  background: #fff;\n  box-shadow: 0 4px 16px rgba(47,128,237,0.10);\n}\n\n.empty-center-wrapper {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: center;\n  min-height: 90vh;\n  width: 100%;\n  background-image: url('/public/imagebg.png');\n  background-size: contain;\n  background-position: center;\n  background-repeat: no-repeat;\n  padding-top: 20vh;\n  transition: all 0.6s cubic-bezier(0.4, 0, 0.2, 1);\n  opacity: 1;\n  transform: translateY(0);\n}\n\n.empty-center-wrapper.fading {\n  opacity: 0;\n  transform: translateY(-20px);\n}\n\n.empty-chat-headline {\n  text-align: center;\n  font-size: 20px;\n  font-weight: 700;\n  color: #686868;\n  margin-bottom: 20px;\n  letter-spacing: -0.5px;\n  line-height: 60px;\n  opacity: 0.92;\n}\n\n.bot-picker-row {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  padding: 0;\n  margin-top: 32px;\n  margin-bottom: 18px;\n  background: none;\n  border-top: none;\n  border-bottom: none;\n  transition: all 0.6s cubic-bezier(0.4, 0, 0.2, 1);\n  opacity: 1;\n  transform: translateY(0);\n}\n\n.bot-picker-row.fading {\n  opacity: 0;\n  transform: translateY(-10px);\n}\n\n.bot-picker-btn {\n  background: #EEECF9;\n  color: #2F80ED;\n  border: none;\n  border-radius: 999px;\n  padding: 8px 20px;\n  font-size: 1rem;\n  font-weight: 500;\n  margin-right: 6px;\n  cursor: pointer;\n  transition: background 0.18s, color 0.18s, box-shadow 0.18s;\n  box-shadow: 0 1px 4px rgba(23,32,43,0.04);\n  outline: none;\n  position: relative;\n}\n\n.bot-picker-btn:last-child {\n  margin-right: 0;\n}\n\n.bot-picker-btn:hover:not(:disabled), .bot-picker-btn:focus:not(:disabled) {\n  background: #2654FF1A;\n  color: #EEECF9;\n  box-shadow: 0 2px 8px rgba(47,128,237,0.08);\n}\n\n.bot-picker-btn.active {\n  background: #2654FF1A;\n  color: #EEECF9;\n  font-weight: bold;\n  box-shadow: 0 4px 16px rgba(47,128,237,0.10);\n}\n\n.bot-picker-btn:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n}\n\n.bot-btn-tooltip-wrapper {\n  position: relative;\n  display: inline-block;\n}\n\n.bot-tooltip {\n  visibility: hidden;\n  opacity: 0;\n  position: absolute;\n  left: 50%;\n  top: 120%;\n  transform: translateX(-50%);\n  background: #EEECF9;\n  color: #17202B;\n  padding: 7px 16px;\n  border-radius: 8px;\n  font-size: 0.98rem;\n  font-weight: 500;\n  white-space: nowrap;\n  pointer-events: none;\n  z-index: 10;\n  box-shadow: 0 2px 8px rgba(23,32,43,0.10);\n  transition: opacity 0.18s, visibility 0.18s;\n  max-width: 250px;\n  width: 250%;\n  word-wrap: break-word;\n  white-space: normal;\n  text-align: center;\n}\n\n.disclaimer-text {\n  font-size: 14px;\n  color: #B5B5B5;\n  text-align: center;\n  width: 60%;\n  max-width: 1300px;\n  margin: 0 auto;\n}\n\n/* Responsive width adjustments for disclaimer text */\n@media (max-width: 1199px) {\n  .disclaimer-text {\n    width: 80%;\n  }\n}\n\n@media (max-width: 899px) {\n  .disclaimer-text {\n    width: 90%;\n    font-size: 13px;\n  }\n}\n\n@media (max-width: 767px) {\n  .disclaimer-text {\n    width: 95%;\n    font-size: 12px;\n  }\n}\n\n@media (max-width: 599px) {\n  .disclaimer-text {\n    width: 98%;\n    font-size: 11px;\n  }\n}\n\n@media (max-width: 479px) {\n  .disclaimer-text {\n    width: 99%;\n    font-size: 10px;\n  }\n}\n\n@media (max-width: 319px) {\n  .disclaimer-text {\n    width: 100%;\n    font-size: 9px;\n  }\n}\n\n.tooltip-title {\n  display: block;\n  font-weight: 600;\n  margin-bottom: 5px;\n}\n\n.tooltip-content {\n  display: block;\n  font-weight: 400;\n}\n\n.bot-btn-tooltip-wrapper:hover .bot-tooltip {\n  visibility: visible;\n  opacity: 1;\n}\n\n.indicator{\n  width: 60%;\n  max-width: 1300px;\n  padding-bottom: 1rem;\n}\n\n/* Responsive width adjustments for indicator */\n@media (max-width: 1199px) {\n  .indicator {\n    width: 80%;\n  }\n}\n\n@media (max-width: 899px) {\n  .indicator {\n    width: 90%;\n  }\n}\n\n@media (max-width: 767px) {\n  .indicator {\n    width: 95%;\n  }\n}\n\n@media (max-width: 599px) {\n  .indicator {\n    width: 98%;\n  }\n}\n\n@media (max-width: 479px) {\n  .indicator {\n    width: 99%;\n  }\n}\n\n.typing-indicator {\n  display: inline-flex;\n  align-items: flex-end;\n  font-size: 1.1rem;\n  color: #2F80ED;\n  font-weight: 500;\n  letter-spacing: 0.5px;\n}\n\n.typing-indicator .dot {\n  display: inline-block;\n  width: 4px;\n  height: 4px;\n  margin-left: 2px;\n  margin-right: 2px;\n  border-radius: 50%;\n  background: #2F80ED;\n  opacity: 0.7;\n  animation: typing-jump 1.2s infinite both;\n  position: relative;\n  bottom: 5px;\n}\n\n.typing-indicator .dot:nth-child(2) {\n  animation-delay: 0.2s;\n}\n.typing-indicator .dot:nth-child(3) {\n  animation-delay: 0.4s;\n}\n\n@keyframes typing-jump {\n  0%, 80%, 100% {\n    transform: translateY(0);\n    opacity: 0.7;\n  }\n  40% {\n    transform: translateY(-8px);\n    opacity: 1;\n  }\n}\n\n.message-actions-row {\n  display: flex;\n  justify-content: flex-start;\n  align-items: flex-start;\n  max-width: 1300px;\n  width: 60%;\n  padding: 0px 0px;\n  margin: 0 auto;\n}\n\n/* Responsive width adjustments for message actions row */\n@media (max-width: 1199px) {\n  .message-actions-row {\n    width: 80%;\n  }\n}\n\n@media (max-width: 899px) {\n  .message-actions-row {\n    width: 90%;\n  }\n}\n\n@media (max-width: 767px) {\n  .message-actions-row {\n    width: 95%;\n  }\n}\n\n@media (max-width: 599px) {\n  .message-actions-row {\n    width: 98%;\n  }\n}\n\n@media (max-width: 479px) {\n  .message-actions-row {\n    width: 99%;\n  }\n}\n\n.copy-btn, .like-btn, .dislike-btn {\n  background: none;\n  border: none;\n  color: #b0b0b0;\n  font-size: 1.1rem;\n  cursor: pointer;\n  padding: 2px 6px;\n  border-radius: 6px;\n  transition: background 0.18s, color 0.18s;\n  outline: none;\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.copy-btn:hover, .like-btn:hover, .dislike-btn:hover,\n.copy-btn:focus, .like-btn:focus, .dislike-btn:focus {\n  background: #e6f0fa;\n  color: #005ea2;\n}\n\n.like-btn:disabled, .dislike-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.feedback-thanks {\n  color: #005ea2;\n  font-size: 0.98rem;\n  margin-left: 8px;\n  opacity: 0;\n  animation: feedback-fadein 0.3s forwards;\n  align-self: center;\n}\n\n@keyframes feedback-fadein {\n  to { opacity: 1; }\n}\n\n.copy-btn-wrapper {\n  position: relative;\n  display: inline-block;\n}\n\n.copied-tooltip {\n  position: absolute;\n  left: 50%;\n  top: 120%;\n  transform: translateX(-50%) translateY(0);\n  background: #005ea2;\n  color: #fff;\n  padding: 3px 9px;\n  border-radius: 6px;\n  font-size: 0.75rem;\n  font-weight: 500;\n  white-space: nowrap;\n  pointer-events: none;\n  z-index: 10;\n  opacity: 0;\n  animation: copied-fadeup 1.2s;\n}\n\n.tab-btn-content svg {\n  width: 20px;\n  height: 20px;\n  margin-right: 8px;\n  margin-bottom: 3px;\n  vertical-align: middle;\n  display: inline-block;\n}\n\n@keyframes copied-fadeup {\n  0% {\n    opacity: 0;\n    transform: translateX(-50%) translateY(-8px);\n  }\n  20% {\n    opacity: 1;\n    transform: translateX(-50%) translateY(0);\n  }\n  80% {\n    opacity: 1;\n    transform: translateX(-50%) translateY(0);\n  }\n  100% {\n    opacity: 0;\n    transform: translateX(-50%) translateY(8px);\n  }\n}\n\n@keyframes expandDown {\n  0% {\n    opacity: 0;\n    transform: scaleY(0);\n    max-height: 0;\n  }\n  100% {\n    opacity: 1;\n    transform: scaleY(1);\n    max-height: 200px;\n  }\n}\n\n/* Large Desktop (1400px and above) */\n@media (min-width: 1400px) {\n  .message, .message.user, .message.ai {\n    font-size: 1.2rem;\n  }\n  \n  .input-card {\n    width: 70%;\n    max-width: 1500px;\n  }\n  \n  .action-buttons {\n    width: 70%;\n    max-width: 1600px;\n  }\n  \n  .empty-chat-headline {\n    font-size: 24px;\n  }\n}\n\n/* Desktop (1200px - 1399px) */\n@media (max-width: 1399px) and (min-width: 1200px) {\n  \n  .input-card {\n    width: 65%;\n  }\n  \n  .action-buttons {\n    width: 75%;\n  }\n}\n\n/* Large Tablet (900px - 1199px) */\n@media (max-width: 1199px) and (min-width: 900px) {\n  .message, .message.user, .message.ai {\n    padding: 16px 16px;\n    font-size: 1.05rem;\n  }\n\n  .ai-message-wrapper + .message-actions-row {\n    width: 45% !important;\n  }\n  \n  .input-area {\n    max-width: 85vw;\n  }\n  \n  .input-card {\n    width: 80%;\n    padding: 16px 24px;\n  }\n  \n  .action-buttons {\n    width: 80%;\n    gap: 14px;\n  }\n  \n  .action-btn {\n    padding: 14px 18px;\n    font-size: 0.88rem;\n  }\n  \n  .messages {\n    padding: 8px 0 20px 0;\n  }\n  \n  .message-actions-row {\n    padding: 16px 16px;\n  }\n  \n  .bot-picker-btn {\n    padding: 7px 16px;\n    font-size: 0.98rem;\n  }\n  \n  .empty-chat-headline {\n    font-size: 18px;\n  }\n}\n\n/* Tablet (768px - 899px) */\n@media (max-width: 899px) and (min-width: 768px) {\n  .message, .message.user, .message.ai {\n    padding: 14px 14px;\n    font-size: 1rem;\n  }\n  \n  .input-area {\n    max-width: 90vw;\n    margin: 0 auto 0 auto;\n    padding: 0 1px;\n  }\n  \n  .chat-input {\n    font-size: 1rem;\n    padding: 14px 12px;\n  }\n  \n  .send-btn {\n    font-size: 1rem;\n    padding: 0 16px;\n    height: 44px;\n  }\n  \n  .messages {\n    padding: 6px 0 18px 0;\n    gap: 6px;\n    max-width: 99%;\n    align-items: center;\n    overflow-y: auto;\n  }\n  \n  .bot-picker-btn {\n    padding: 6px 12px;\n    font-size: 0.95rem;\n    margin-right: 4px;\n    min-width: 0;\n    height: auto;\n  }\n  \n  .message-actions-row {\n    gap: 6px;\n    font-size: 0.98rem;\n    margin-bottom: 12px;\n    margin-left: 0px;\n    padding: 14px 8vw;\n  }\n  \n  .copy-btn, .like-btn, .dislike-btn {\n    font-size: 1rem;\n    padding: 2px 4px;\n  }\n  \n  .feedback-thanks {\n    font-size: 0.93rem;\n    margin-left: 5px;\n  }\n  \n  .empty-chat-headline {\n    font-size: 1.5rem;\n    margin-top: 7vh;\n    margin-bottom: 28px;\n  }\n  \n  .bot-tooltip {\n    max-width: 250px;\n    font-size: 0.9rem;\n    padding: 6px 12px;\n    width: 250%;\n  }\n  \n  .input-card {\n    padding: 14px 20px;\n  }\n  \n  .action-buttons {\n    width: 90%;\n    gap: 12px;\n  }\n  \n  .action-btn {\n    padding: 12px 16px;\n    font-size: 0.85rem;\n  }\n}\n\n/* Large Mobile (600px - 767px) */\n@media (max-width: 767px) and (min-width: 600px) {\n  .message, .message.user, .message.ai {\n    padding: 12px 4vw;\n    font-size: 0.98rem;\n  }\n  \n  .message-actions-row {\n    padding: 12px 4vw;\n    font-size: 0.95rem;\n  }\n  \n  .input-area {\n    max-width: 92vw;\n    padding: 0 2px;\n  }\n  \n  .chat-input {\n    font-size: 0.98rem;\n    padding: 12px 10px;\n  }\n  \n  .send-btn {\n    font-size: 0.98rem;\n    padding: 0 12px;\n    height: 42px;\n  }\n  \n  .messages {\n    padding: 6px 0 16px 0;\n  }\n  \n  .bot-picker-btn {\n    padding: 5px 10px;\n    font-size: 0.92rem;\n  }\n  \n  .bot-picker-row {\n    gap: 8px;\n    flex-wrap: wrap;\n  }\n  \n  .message-actions-row {\n    gap: 5px;\n    font-size: 0.95rem;\n    padding: 12px 4vw;\n  }\n  \n  .copy-btn, .like-btn, .dislike-btn {\n    font-size: 0.97rem;\n    padding: 2px 3px;\n  }\n  \n  .empty-chat-headline {\n    font-size: 1.3rem;\n    margin-top: 6vh;\n  }\n  \n  .input-card {\n    padding: 12px 16px;\n  }\n  \n  .action-buttons {\n    width: 95%;\n    gap: 10px;\n  }\n  \n  .action-btn {\n    padding: 11px 14px;\n    font-size: 0.82rem;\n  }\n}\n\n/* Mobile (480px - 599px) */\n@media (max-width: 599px) and (min-width: 480px) {\n  .message, .message.user, .message.ai {\n    padding: 12px 3vw;\n    font-size: 0.97rem;\n  }\n  \n  .message-actions-row {\n    padding: 12px 3vw;\n    font-size: 0.93rem;\n  }\n  \n  .input-area {\n    max-width: 90vw;\n    margin: 0 auto 0 auto;\n    padding: 0 0.5px;\n  }\n  \n  .chat-input {\n    font-size: 0.97rem;\n    padding: 10px 8px;\n    margin-right: 6px;\n  }\n  \n  .send-btn {\n    font-size: 0.97rem;\n    padding: 0 10px;\n    height: 40px;\n  }\n  \n  .messages {\n    padding: 6px 0 18px 0;\n    align-items: center;\n    width: 99%;\n  }\n  \n  .bot-picker-btn {\n    padding: 4px 8px;\n    font-size: 0.91rem;\n    margin-right: 2px;\n    min-width: 0;\n    height: auto;\n  }\n  \n  .bot-picker-row {\n    padding: 10px 8px 0 8px;\n    gap: 6px;\n    flex-wrap: wrap;\n  }\n  \n  .message-actions-row {\n    gap: 4px;\n    font-size: 0.93rem;\n    margin-bottom: 8px;\n    margin-left: auto;\n    margin-right: auto;\n    padding: 0!important;\n    max-width: 90vw;\n  }\n  \n  .copy-btn, .like-btn, .dislike-btn {\n    font-size: 0.95rem;\n    padding: 1px 2px;\n  }\n  \n  .feedback-thanks {\n    font-size: 0.9rem;\n    margin-left: 3px;\n  }\n  \n  .empty-chat-headline {\n    font-size: 1.15rem;\n    margin-top: 4vh;\n    margin-bottom: 18px;\n  }\n  \n  .bot-tooltip {\n    max-width: 250px;\n    font-size: 0.75rem;\n    padding: 5px 10px;\n    top: 110%;\n    width: 150%;\n  }\n  \n  .input-card {\n    padding: 10px 12px;\n  }\n  \n  .action-buttons {\n    width: 98%;\n    gap: 8px;\n  }\n  \n  .action-btn {\n    padding: 10px 12px;\n    font-size: 0.8rem;\n  }\n}\n\n/* Small Mobile (320px - 479px) */\n@media (max-width: 479px) and (min-width: 320px) {\n  .message, .message.user, .message.ai {\n    padding: 10px 2vw;\n    font-size: 0.95rem;\n  }\n  \n  .message-actions-row {\n    padding: 10px 2vw;\n    font-size: 0.9rem;\n  }\n  \n  .input-area {\n    max-width: 88vw;\n    padding: 0 1px;\n  }\n  \n  .chat-input {\n    font-size: 0.95rem;\n    padding: 8px 6px;\n    margin-right: 4px;\n  }\n  \n  .send-btn {\n    font-size: 0.95rem;\n    padding: 0 8px;\n    height: 38px;\n  }\n  \n  .messages {\n    padding: 4px 0 14px 0;\n  }\n  \n  .bot-picker-btn {\n    padding: 3px 6px;\n    font-size: 0.88rem;\n    margin-right: 1px;\n  }\n  \n  .bot-picker-row {\n    padding: 8px 6px 0 6px;\n    gap: 4px;\n  }\n  \n  .message-actions-row {\n    gap: 3px;\n    font-size: 0.9rem;\n    padding: 10px 2vw;\n  }\n  \n  .copy-btn, .like-btn, .dislike-btn {\n    font-size: 0.92rem;\n    padding: 1px 1px;\n  }\n  \n  .empty-chat-headline {\n    font-size: 1rem;\n    margin-top: 3vh;\n    margin-bottom: 16px;\n  }\n  \n  .input-card {\n    padding: 8px 10px;\n  }\n  \n  .action-buttons {\n    width: 100%;\n    gap: 6px;\n  }\n  \n  .action-btn {\n    padding: 8px 10px;\n    font-size: 0.78rem;\n    min-height: 60px;\n  }\n  \n  .action-btn span {\n    font-size: 0.72rem;\n  }\n  \n  .example-item {\n    padding: 6px 10px;\n    font-size: 0.72rem;\n  }\n}\n\n/* Extra Small Mobile (below 320px) */\n@media (max-width: 319px) {\n  .message, .message.user, .message.ai {\n    padding: 8px 1vw;\n    font-size: 0.9rem;\n  }\n  \n  .message-actions-row {\n    padding: 8px 1vw;\n    font-size: 0.85rem;\n  }\n  \n  .input-area {\n    max-width: 85vw;\n  }\n  \n  .chat-input {\n    font-size: 0.9rem;\n    padding: 6px 4px;\n  }\n  \n  .send-btn {\n    font-size: 0.9rem;\n    height: 36px;\n  }\n  \n  .bot-picker-btn {\n    padding: 2px 4px;\n    font-size: 0.85rem;\n  }\n  \n  .empty-chat-headline {\n    font-size: 0.9rem;\n    margin-top: 2vh;\n  }\n  \n  .input-card {\n    padding: 6px 8px;\n  }\n  \n  .action-btn {\n    padding: 6px 8px;\n    font-size: 0.75rem;\n    min-height: 50px;\n  }\n  \n  .action-btn span {\n    font-size: 0.7rem;\n  }\n  \n  .example-item {\n    padding: 4px 8px;\n    font-size: 0.7rem;\n  }\n}\n\n/* Landscape orientation adjustments for mobile */\n@media (max-width: 900px) and (orientation: landscape) {\n  .empty-center-wrapper {\n    min-height: 70vh;\n    padding-top: 10vh;\n  }\n  \n  .empty-chat-headline {\n    font-size: 1.2rem;\n    margin-top: 2vh;\n    margin-bottom: 12px;\n  }\n  \n  .bot-picker-row {\n    margin-top: 16px;\n    margin-bottom: 12px;\n  }\n  \n  .messages {\n    padding: 4px 0 12px 0;\n  }\n  \n  .input-area.with-messages {\n    margin-top: 8px;\n    margin-bottom: 8px;\n  }\n}\n\n/* High DPI displays */\n@media (-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi) {\n  .chat-input, .send-btn, .bot-picker-btn, .action-btn {\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n  }\n}\n\n/* Reduced motion for accessibility */\n@media (prefers-reduced-motion: reduce) {\n  .chat-area,\n  .message,\n  .input-area,\n  .chat-input,\n  .send-btn,\n  .bot-picker-btn,\n  .action-btn,\n  .typing-indicator .dot,\n  .expanded-examples {\n    transition: none;\n    animation: none;\n  }\n  \n  .typing-indicator .dot {\n    animation: none;\n  }\n}\n\n/* Markdown formatting styles */\n.markdown-content {\n  width: 100%;\n}\n\n.markdown-paragraph {\n  margin-bottom: 0px;\n  line-height: 1.5;\n  font-size: 16px;\n}\n\n.markdown-heading {\n  margin-top: 18px;\n  margin-bottom: 16px;\n  font-weight: 600;\n  line-height: 1.25;\n}\n\n.markdown-heading:first-child {\n  margin-top: 0;\n}\n\nh1.markdown-heading {\n  font-size: 19px;\n}\n\nh2.markdown-heading {\n  font-size: 18px;\n}\n\nh3.markdown-heading {\n  font-size: 17px;\n}\n\n.markdown-list, .markdown-ordered-list {\n  margin-bottom: 16px;\n  padding-left: 2em;\n  font-size: 16px;\n}\n\n.markdown-list-item {\n  margin-bottom: 6px;\n}\n\n.markdown-divider {\n  height: 0.25em;\n  margin: 24px 0;\n  background-color: rgba(0, 0, 0, 0.1);\n  border: 0;\n}\n\n.markdown-blockquote {\n  padding: 0 1em;\n  margin-left: 0;\n  margin-right: 0;\n  color: #6a737d;\n  border-left: 0.25em solid #dfe2e5;\n}\n\n.markdown-code-block {\n  padding: 16px;\n  overflow: auto;\n  font-size: 85%;\n  line-height: 1.45;\n  background-color: #f6f8fa;\n  border-radius: 3px;\n  margin-bottom: 16px;\n  white-space: pre-wrap;\n}\n\n/* Dark theme adjustments */\n.message.ai .markdown-code-block {\n  background-color: #2d333b;\n  color: #e6edf3;\n}\n\n.message.ai .markdown-blockquote {\n  border-left-color: #444c56;\n  color: #adbac7;\n}\n\n.message.ai .markdown-divider {\n  background-color: rgba(255, 255, 255, 0.1);\n}\n\n/* Add styles for message actions alignment */\n.message.user + .message-actions-row {\n  justify-content: end;\n}\n\n.ai-message-wrapper + .message-actions-row {\n  justify-content: center;\n  width: 55%;\n  margin-left: 0px; /* Align with AI message content (avatar width + gap) */\n}\n\n.input-card {\n  background: #F9F9F9;\n  border: 1px solid #D5D5D5;\n  border-radius: 24px;\n  box-shadow: 0 2px 16px rgba(23,32,43,0.06);\n  padding: 12px 32px 12px 32px;\n  width: 60%;\n  max-width: 1300px;\n  margin: 0 auto 0 auto;\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  position: relative;\n  z-index: 2;\n}\n\n/* Responsive width adjustments for input card */\n@media (max-width: 1199px) {\n  .input-card {\n    width: 80%;\n  }\n}\n\n@media (max-width: 899px) {\n  .input-card {\n    width: 90%;\n  }\n}\n\n@media (max-width: 767px) {\n  .input-card {\n    width: 95%;\n  }\n}\n\n@media (max-width: 599px) {\n  .input-card {\n    width: 98%;\n  }\n}\n\n@media (max-width: 479px) {\n  .input-card {\n    width: 99%;\n  }\n}\n\n.tab-buttons {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 18px;\n  margin-top: 18px;\n}\n\n.tab-btn {\n  background: #fff;\n  color: #878787;\n  border: none;\n  border-radius: 10px;\n  padding: 8px 22px;\n  font-size: 1rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background 0.18s, color 0.18s, box-shadow 0.18s;\n  outline: none;\n  box-shadow: 0 1px 4px rgba(23,32,43,0.04);\n}\n\n.tab-btn.active {\n  background: #2654FF1A;\n  color: #132775;\n  font-weight: 400;\n  box-shadow: 0 4px 16px rgba(47,128,237,0.10);\n}\n\n.tab-btn:hover {\n  background: #2654FF1A;\n  color: #132775;\n  font-weight: 400;\n  box-shadow: 0 4px 16px rgba(47,128,237,0.10);\n}\n\n.input-row {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  width: 100%;\n}\n\n.input-card .chat-input {\n  flex: 1;\n  padding: 18px 0px;\n  border-radius: 18px;\n  border: none !important;\n  background: #F9F9F9;\n  color: #686868;\n  font-size: 16px;\n  font-weight: 700;\n  font-family: 'Gilroy', sans-serif;\n  outline: none;\n  transition: border 0.2s, box-shadow 0.2s;\n  box-shadow: none !important;\n  min-width: 0;\n}\n\n.input-card .chat-input::placeholder {\n  color: #AEAEAE;\n  font-weight: 400;\n  font-size: 16px;\n  padding: 0;\n}\n\n.input-card .chat-input:focus {\n  background: #F9F9F9;\n}\n\n.send-btn {\n  background: #2654FF1A;\n  color:#132775;\n  border: none;\n  border-radius: 50%;\n  width: 48px;\n  height: 48px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.2rem;\n  cursor: pointer;\n  transition: background 0.2s, color 0.2s, box-shadow 0.2s;\n  box-shadow: 0 2px 8px rgba(23,32,43,0.06);\n}\n\n.send-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.send-btn:hover:not(:disabled), .send-btn:focus:not(:disabled) {\n  background: #132775;\n  color: #fff;\n  box-shadow: 0 4px 16px rgba(47,128,237,0.10);\n}\n\n/* Medium Tablet and below (700px and below) - Enhanced responsive design */\n@media (max-width: 700px) {\n  .input-card {\n    padding: 18px 8px 14px 8px;\n  }\n  \n  .tab-buttons {\n    gap: 6px;\n    margin-bottom: 10px;\n  }\n  \n  .input-card .chat-input {\n    padding: 14px 10px;\n    font-size: 1rem;\n  }\n  \n  .send-btn {\n    width: 40px;\n    height: 40px;\n    font-size: 1rem;\n  }\n  \n  .action-buttons {\n    width: 95%;\n    gap: 10px;\n    margin-top: 18px;\n    margin-bottom: 10px;\n  }\n  \n  .action-btn {\n    padding: 12px 14px;\n    font-size: 0.83rem;\n    min-height: 65px;\n  }\n  \n  .action-btn span {\n    font-size: 0.78rem;\n  }\n  \n  .example-item {\n    padding: 9px 14px;\n    font-size: 0.78rem;\n  }\n  \n  .message, .message.user, .message.ai {\n    padding: 13px 6vw;\n    font-size: 0.99rem;\n  }\n  \n  .message-actions-row {\n    padding: 13px 6vw;\n  }\n  \n  .input-area {\n    max-width: 92vw;\n  }\n  \n  .chat-input {\n    font-size: 0.99rem;\n    padding: 12px 10px;\n  }\n  \n  .bot-picker-btn {\n    padding: 6px 11px;\n    font-size: 0.93rem;\n  }\n  \n  .empty-chat-headline {\n    font-size: 1.4rem;\n    margin-top: 6vh;\n  }\n}\n\n.action-buttons {\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n  gap: 16px;\n  margin-top: 24px;\n  margin-bottom: 16px;\n  width: 78%;\n  max-width: 1400px;\n  margin-left: auto;\n  margin-right: auto;\n  overflow: visible;\n  transition: all 0.6s cubic-bezier(0.4, 0, 0.2, 1);\n  opacity: 1;\n  transform: translateY(0);\n}\n\n.action-buttons.fading {\n  opacity: 0;\n  transform: translateY(-10px);\n}\n\n.action-buttons:not(.expanded) {\n  align-content:baseline; \n}\n\n.action-btn {\n  background: #fff;\n  border: 1px solid #D5D5D5;\n  border-radius: 12px;\n  padding: 16px 20px;\n  font-size: 0.9rem;\n  font-weight: 500;\n  color: #AEAEAE;\n  cursor: pointer;\n  transition: background 0.3s ease, border 0.3s ease, box-shadow 0.3s ease, scale 0.3s ease, border-radius 0.3s ease;\n  outline: none;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex: 1;\n  min-height: 70px;\n  width: 100%;\n  text-align: left;\n  line-height: 1.4;\n  box-shadow: 0 2px 8px rgba(23,32,43,0.04);\n}\n\n.action-btn.expanded {\n  border-bottom-left-radius: 0;\n  border-bottom-right-radius: 0;\n  border-bottom: 1px solid #F0F0F0;\n}\n\n.action-btn:hover {\n  box-shadow: 0 8px 32px rgba(23,32,43,0.08);\n}\n\n.action-btn span {\n  flex: 1;\n  font-size: 0.85rem;\n  line-height: 1.3;\n}\n\n.action-btn svg {\n  color: #132876;\n}\n\n.action-btn-container {\n  position: relative;\n  flex: 1;\n  max-width: 78%;\n  overflow: visible;\n  display: flex;\n  flex-direction: column;\n}\n\n.dropdown-arrow {\n  transition: transform 0.3s ease;\n  color: #AEAEAE;\n  flex-shrink: 0;\n}\n\n.dropdown-arrow.rotated {\n  transform: rotate(180deg);\n}\n\n.expanded-examples {\n  width: 100%;\n  background: #fff;\n  border-right: 1px solid #D5D5D5;\n  border-left: 1px solid #D5D5D5;\n  border-bottom: 1px solid #D5D5D5;\n  border-radius: 0 0 12px 12px;\n  overflow: hidden;\n  margin-top: 0;\n  position: static;\n  box-shadow: 0 4px 16px rgba(23,32,43,0.08);\n  animation: expandDown 0.3s ease-out;\n  transform-origin: top;\n}\n\n.example-item {\n  width: 100%;\n  padding: 12px 20px;\n  background: none;\n  border: none;\n  text-align: left;\n  font-size: 0.9rem;\n  color: #AEAEAE;\n  cursor: pointer;\n  transition: background 0.3s ease, color 0.3s ease, transform 0.2s ease;\n  border-bottom: 1px solid #F0F0F0;\n  line-height: 1.4;\n}\n\n.example-item:last-child {\n  border-bottom: none;\n}\n\n.example-item:hover {\n  color: #132775;\n  transform: translateX(4px);\n}\n\n.example-item:focus {\n  color: #132775;\n  outline: none;\n  transform: translateX(4px);\n}\n\n.example-item:active {\n  color: #132775;\n  transform: translateX(4px) scale(0.98);\n}\n\n/* Tablet and below (900px and below) - Action buttons responsive design */\n@media (max-width: 900px) {\n  .action-buttons {\n    gap: 12px;\n    margin-top: 20px;\n    margin-bottom: 12px;\n    padding: 0 16px;\n    width: 90%;\n  }\n  \n  .action-btn {\n    padding: 12px 16px;\n    font-size: 0.85rem;\n    max-width: 180px;\n    min-height: 68px;\n  }\n  \n  .action-btn span {\n    font-size: 0.8rem;\n  }\n  \n  .expanded-examples {\n    margin-top: 0;\n  }\n  \n  .example-item {\n    padding: 10px 16px;\n    font-size: 0.8rem;\n  }\n  \n  .action-btn-container {\n    max-width: 90%;\n  }\n}\n\n/* Mobile and below (600px and below) - Enhanced responsive design */\n@media (max-width: 600px) {\n  .action-buttons {\n    flex-direction: column;\n    gap: 8px;\n    margin-top: 16px;\n    margin-bottom: 8px;\n    padding: 0 8px;\n  }\n  \n  .action-btn {\n    padding: 10px 14px;\n    font-size: 0.8rem;\n    max-width: 100%;\n    width: 100%;\n  }\n  \n  .action-btn span {\n    font-size: 0.75rem;\n  }\n  \n  .expanded-examples {\n    margin-top: 0;\n  }\n  \n  .example-item {\n    padding: 8px 14px;\n    font-size: 0.75rem;\n  }\n  \n  /* Additional mobile optimizations */\n  .input-card {\n    padding: 12px 16px;\n  }\n  \n  .tab-buttons {\n    gap: 4px;\n    margin-bottom: 8px;\n  }\n  \n  .tab-btn {\n    padding: 6px 12px;\n    font-size: 0.9rem;\n  }\n  \n  .input-card .chat-input {\n    padding: 12px 8px;\n    font-size: 0.95rem;\n  }\n  \n  .send-btn {\n    width: 38px;\n    height: 38px;\n    font-size: 0.95rem;\n  }\n  \n  .message, .message.user, .message.ai {\n    padding: 12px 12px;\n    font-size: 0.96rem;\n  }\n  \n  .message-actions-row {\n    padding: 12px 3vw;\n  }\n  \n  .input-area {\n    max-width: 92vw;\n    padding: 0 2px;\n  }\n  \n  .chat-input {\n    font-size: 0.96rem;\n    padding: 10px 8px;\n  }\n  \n  .messages {\n    padding: 6px 0 16px 0;\n  }\n  \n  .bot-picker-btn {\n    padding: 5px 10px;\n    font-size: 0.9rem;\n  }\n  \n  .message-actions-row {\n    gap: 4px;\n    font-size: 0.94rem;\n    padding: 12px 3vw;\n  }\n  \n  .copy-btn, .like-btn, .dislike-btn {\n    font-size: 0.94rem;\n    padding: 2px 3px;\n  }\n  \n  .empty-chat-headline {\n    font-size: 1.2rem;\n    margin-top: 5vh;\n  }\n}\n\n/* Touch device optimizations */\n@media (hover: none) and (pointer: coarse) {\n  .copy-btn, .like-btn, .dislike-btn {\n    min-height: 44px;\n    min-width: 44px;\n    padding: 8px 12px;\n  }\n  \n  .bot-picker-btn {\n    min-height: 44px;\n    padding: 8px 16px;\n  }\n  \n  .send-btn {\n    min-height: 44px;\n    min-width: 44px;\n  }\n  \n  .action-btn {\n    min-height: 60px;\n  }\n  \n  .tab-btn {\n    min-height: 44px;\n    padding: 10px 20px;\n  }\n  \n  .example-item {\n    min-height: 44px;\n    padding: 12px 20px;\n  }\n}\n\n/* High contrast mode support */\n@media (prefers-contrast: high) {\n  .message.user {\n    border: 2px solid #17202B;\n  }\n  \n  .chat-input {\n    border: 2px solid #17202B;\n  }\n  \n  .send-btn {\n    border: 2px solid #132775;\n  }\n  \n  .action-btn {\n    border: 2px solid #D5D5D5;\n  }\n  \n  .bot-picker-btn {\n    border: 2px solid #2F80ED;\n  }\n}\n\n/* Print styles */\n@media print {\n  .chat-area {\n    background: white !important;\n    color: black !important;\n  }\n  \n  .input-area,\n  .send-btn,\n  .action-buttons,\n  .bot-picker-row {\n    display: none !important;\n  }\n  \n  .message {\n    break-inside: avoid;\n    page-break-inside: avoid;\n  }\n}\n\n/* Focus visible for better accessibility */\n.copy-btn:focus-visible,\n.like-btn:focus-visible,\n.dislike-btn:focus-visible,\n.send-btn:focus-visible,\n.bot-picker-btn:focus-visible,\n.action-btn:focus-visible,\n.tab-btn:focus-visible,\n.example-item:focus-visible {\n  outline: 2px solid #2F80ED;\n  outline-offset: 2px;\n}\n\n/* Improved scrolling for mobile */\n@media (max-width: 900px) {\n  .messages {\n    -webkit-overflow-scrolling: touch;\n    scroll-behavior: smooth;\n  }\n  \n  .chat-input {\n    -webkit-appearance: none;\n    border-radius: 24px;\n  }\n  \n  .send-btn {\n    -webkit-tap-highlight-color: transparent;\n  }\n}\n\n/* Landscape phone optimizations */\n@media (max-width: 900px) and (orientation: landscape) and (max-height: 500px) {\n  .empty-center-wrapper {\n    min-height: 60vh;\n    padding-top: 5vh;\n  }\n  \n  .empty-chat-headline {\n    font-size: 1rem;\n    margin-top: 2vh;\n    margin-bottom: 8px;\n  }\n  \n  .bot-picker-row {\n    margin-top: 8px;\n    margin-bottom: 8px;\n  }\n  \n  .messages {\n    padding: 2px 0 8px 0;\n  }\n  \n  .input-area.with-messages {\n    margin-top: 4px;\n    margin-bottom: 4px;\n  }\n  \n  .action-buttons {\n    margin-top: 8px;\n    margin-bottom: 6px;\n  }\n  \n  .action-btn {\n    min-height: 50px;\n    padding: 8px 12px;\n  }\n}\n\n/* Ultra-wide screen support */\n@media (min-width: 2000px) {\n  .message, .message.user, .message.ai {\n    max-width: 1300px;\n    font-size: 1.3rem;\n  }\n  \n  .input-card {\n    width: 60%;\n    max-width: 1600px;\n  }\n  \n  .action-buttons {\n    width: 60%;\n    max-width: 1800px;\n  }\n  \n  .empty-chat-headline {\n    font-size: 28px;\n  }\n  \n  .bot-picker-btn {\n    font-size: 1.1rem;\n    padding: 10px 24px;\n  }\n  \n  .chat-input {\n    font-size: 1.2rem;\n    padding: 24px 0px;\n  }\n  \n  .send-btn {\n    width: 56px;\n    height: 56px;\n    font-size: 1.4rem;\n  }\n}\n\n.ai-message-row {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n}\n\n.ai-message-wrapper {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  margin-bottom: 16px;\n  justify-content: flex-start;\n  width: 60%;\n  max-width: 1300px;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n/* Responsive width adjustments for AI message wrapper */\n@media (max-width: 1199px) {\n  .ai-message-wrapper {\n    width: 80%;\n  }\n}\n\n@media (max-width: 899px) {\n  .ai-message-wrapper {\n    width: 90%;\n  }\n}\n\n@media (max-width: 767px) {\n  .ai-message-wrapper {\n    width: 95%;\n  }\n}\n\n@media (max-width: 599px) {\n  .ai-message-wrapper {\n    width: 98%;\n  }\n}\n\n@media (max-width: 479px) {\n  .ai-message-wrapper {\n    width: 99%;\n  }\n}\n\n.ai-avatar-wrapper{\n  width: 45px;\n  height: 45px;\n  background: #2654FF1A;\n  border-radius: 50%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-top: 8px;\n  flex-shrink: 0;\n}\n\n.ai-avatar{\n  width: 20px;\n  height: 20px;\n  object-fit: contain;\n}\n\n/* Responsive avatar adjustments */\n@media (max-width: 1199px) {\n  .ai-avatar-wrapper {\n    width: 42px;\n    height: 42px;\n  }\n  \n  .ai-avatar {\n    width: 18px;\n    height: 18px;\n  }\n}\n\n@media (max-width: 899px) {\n  .ai-avatar-wrapper {\n    width: 40px;\n    height: 40px;\n  }\n  \n  .ai-avatar {\n    width: 17px;\n    height: 17px;\n  }\n}\n\n@media (max-width: 767px) {\n  .ai-avatar-wrapper {\n    width: 38px;\n    height: 38px;\n  }\n  \n  .ai-avatar {\n    width: 16px;\n    height: 16px;\n  }\n}\n\n@media (max-width: 599px) {\n  .ai-avatar-wrapper {\n    width: 36px;\n    height: 36px;\n  }\n  \n  .ai-avatar {\n    width: 15px;\n    height: 15px;\n  }\n}\n\n@media (max-width: 479px) {\n  .ai-avatar-wrapper {\n    width: 34px;\n    height: 34px;\n  }\n  \n  .ai-avatar {\n    width: 14px;\n    height: 14px;\n  }\n}\n\n@media (max-width: 319px) {\n  .ai-avatar-wrapper {\n    width: 32px;\n    height: 32px;\n  }\n  \n  .ai-avatar {\n    width: 13px;\n    height: 13px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
